export const appHead = {"meta":[{"charset":"utf8"},{"name":"viewport","content":"width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"},{"name":"apple-mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-status-bar-style","name":"apple-mobile-web-app-status-bar-style","content":"black-translucent"},{"name":"apple-mobile-web-app-title","content":"FOX789"},{"hid":"description","content":"FOX789"},{"name":"google-site-verification","content":"lAlXkZDYrFA_JG1lb1tZObS2YxqnP8EgkU_flCt__8Q"}],"link":[{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=IBM+Plex+Sans+Thai:wght@100;200;300;400;500;600;700&display=swap"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap"},{"rel":"stylesheet","href":"https://fonts.googleapis.com/css?family=Roboto:wght@100..900&display=swap"},{"rel":"preconnect","href":"https://fonts.googleapis.com"},{"rel":"preconnect","href":"https://fonts.gstatic.com"},{"rel":"icon","type":"image/png","sizes":"16x16","href":"/assets/favicon.png"},{"rel":"icon","type":"image/png","sizes":"32x32","href":"/assets/favicon.png"},{"rel":"icon","type":"image/png","sizes":"96x96","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"57x57","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"60x60","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"72x72","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"76x76","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"114x114","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"120x120","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"144x144","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"152x152","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"180x180","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"256x256","href":"/assets/favicon.png"},{"rel":"apple-touch-icon","sizes":"512x512","href":"/assets/favicon.png"}],"style":[],"script":[],"noscript":[],"title":"FOX789"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"